import type { FaireProductEntity } from "../../entity_types/product";

export const p_3732v43nq3: FaireProductEntity = {
  token: "p_3732v43nq3",
  type: "product",
  name: "Crying On The Inside Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/567b016f2f80db7bca0ba8c7f0adb020b5ecbd56cd446504763a33322a13b212.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b3684b5ea9e2b4c1d85e9822c3ef4a9908d964cfb0d4db7c262bfc36d78eb93.jpeg",
    "https://cdn.faire.com/fastly/afd3b681971b07f29cd4e90d3e821bb2dae2070aa4888724fd29dca863a157d0.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/f13c628afa92cb8f20675a374139c200a1ab2defe28bdc08d5067f9d256993a2.jpeg",
    "https://cdn.faire.com/fastly/bb2321047830999ff2b4da1d733abee52d43f11c0d49034379abb944a7b98660.jpeg",
    "https://cdn.faire.com/fastly/46e06e76db664485e2be0f3e80cef6c248a79a6ec004103d993bb4ae93ed6fac.jpeg",
    "https://cdn.faire.com/fastly/b452697d020b686198f14c285628a20ef1d7a45091bd99534cbf52be9cb72a9e.jpeg"
  ],
  priceDollars: 9.6,
  description: "A grip sock for smiling through it while everything else in you trembles in silent agony. 🥲\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:13.428Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
